module.exports = require('../dist/vue-i18n.cjs')